<template>
    <div class="block">
        <div class="categories-list categories-list--layout--columns-5-sidebar">
            <ul class="categories-list__body">
                <category-item v-for="(category, index) in categories"
                    :key="category.ID"
                    :index="index"
                    :img_category_id="category.DMCD01"
                    :name="category.categoryname"
                    :product_link="category.DMCD01 + '/' + category.categoryname.replace(/ /g, '-')"
                    :total_products="0"
                    :hasDSVEH="category.DSVEH"
                    :category_code="category.DMCD01"
                    @kitDialog="openKitDialog"
                >
                </category-item>
            </ul>
        </div>
    </div>

    <kit-vehicle-dialog @close="kitDialog = false" :open="kitDialog" :main_category="vehicle_category"></kit-vehicle-dialog>

</template>

<script>
import CategoryItem from './CategoryItem.vue';
import KitVehicleDialog from '../kit-group/KitVehicleDialog.vue';

export default {
    components: {
        CategoryItem,
        KitVehicleDialog
    }, 

    data() {
        return {
            // categories: []
            kitDialog: false,
            vehicle_category:'',
        }
    },

    computed: {
        categories() {
            let categories = this.$store.getters['product/format_category'];
            categories.forEach(item => {
                item.isOpen = false;
            });
            return categories;
            // return this.$store.getters['product/format_category'];
        }
    },

    methods: {
        openKitDialog(cat){
            this.vehicle_category = cat;
            this.kitDialog = true;
        }
    },

    created() {
    }
}
</script>
